import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";

import Tooltip, { type TooltipProps } from "./Tooltip";

import InfoIcon from "@material-ui/icons/Info";
import clsx from "clsx";
import type { Theme } from "src/theme";

const useStyles = makeStyles((theme: Theme) => {
  const { derived } = theme.palette.custom;

  return {
    regular: {
      color: derived.accentOnCard,
    },
    error: {
      color: theme.palette.error.main,
    },
    small: {
      fontSize: theme.typography.body2.fontSize,
    },
    hidden: {
      visibility: "hidden",
    },
  };
});

export interface InfoTooltipProps {
  text?: TooltipProps["title"];
  onClick?: IconButtonProps["onClick"];
  size?: "small" | React.CSSProperties["fontSize"];
  className?: string;
  tabIndex?: number;
  color?: "inherit" | "regular" | "error";
  hidden?: boolean;
  disableButton?: boolean;
}

function InfoTooltip({
  text,
  onClick,
  size,
  className,
  tabIndex = -1,
  color = "regular",
  hidden,
  disableButton = false,
  ...rest
}: InfoTooltipProps & Omit<IconButtonProps, "size" | "color">) {
  const classes = useStyles();
  const props = {
    ...rest,
    onClick,
    className: clsx(
      className,
      color === "regular" && classes.regular,
      color === "error" && classes.error,
      size === "small" && classes.small,
      hidden && classes.hidden
    ),
    tabIndex: tabIndex,
    style: {} as React.CSSProperties,
    color: "default" as IconButtonProps["color"],
    component: disableButton ? "span" : undefined,
  };
  if (size && size !== "small") props.style.fontSize = size;
  if (color === "inherit") props.color = "inherit";

  const button = (
    <IconButton {...props}>
      <InfoIcon fontSize="inherit" />
    </IconButton>
  );

  if (text) return <Tooltip title={text}>{button}</Tooltip>;

  return button;
}

export default InfoTooltip;
